import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_LIST_MY_FAIL,
  ORDER_LIST_MY_REQUEST,
  ORDER_LIST_MY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_COD_REQUEST,
  ORDER_COD_SUCCESS,
  ORDER_COD_FAIL,
  ORDER_UPI_REQUEST,
  ORDER_UPI_SUCCESS,
  ORDER_UPI_FAIL,
  UPI_PAY_REQUEST,
  UPI_PAY_SUCCESS,
  UPI_PAY_FAIL,
} from "../Constants/OrderConstants";
import { BASE_URL } from "../Constants/GlobalConstant";

import axios from "axios";
import { CART_CLEAR_ITEMS } from "../Constants/CartConstants";
import { logout } from "./userActions";

// CREATE NEW ORDER
export const createOrder = (order) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(BASE_URL + `/api/orders`, order, config);
    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data });
    dispatch({ type: CART_CLEAR_ITEMS, payload: data });

    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartItemArray");
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload: message,
    });
  }
};

// ORDER DETAIL BASED ON ORDER ID
export const getOrderDetails = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: ORDER_DETAILS_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(BASE_URL + `/api/orders/${id}`, config);
    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    if (message === "Not authorized, token failed") {
      dispatch(logout());
    }
    dispatch({
      type: ORDER_DETAILS_FAIL,
      payload: message,
    });
  }
};

//
// Creating ORDER at Razorpay.
export const UPIOrder =
  (orderId, payloadData) => async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_UPI_REQUEST });

      const config = {
        headers: {
          "Content-Type": "application/json",
          // Authorization: null,
        },
      };

      const { data } = await axios.post(
        BASE_URL + `/api/razorpay/order`,
        payloadData,
        config
      );
      console.log("Razorpay order Created Successfully, Procced for Payment");
      dispatch({ type: ORDER_UPI_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_UPI_FAIL,
        payload: message,
      });
      alert("Seems Internet Issue, Try Again");
    }
  };

// ORDER PAY
export const upiPaymentUpdate =
  (orderId, payloadData) => async (dispatch, getState) => {
    try {
      dispatch({ type: UPI_PAY_REQUEST });

      // const {
      //   userLogin: { userInfo },
      // } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          // Authorization: null,
        },
      };

      const { data } = await axios.put(
        BASE_URL + `/api/orders/${orderId}/upi_pay`,
        payloadData,
        config
      );

      dispatch({ type: UPI_PAY_SUCCESS, payload: data });
      dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: UPI_PAY_FAIL,
        payload: message,
      });
    }
  };

// ORDER COD
export const CODOrder =
  (orderId, paymentResult) => async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_COD_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        BASE_URL + `/api/orders/${orderId}/cod`,
        {},
        config
      );

      dispatch({ type: ORDER_COD_SUCCESS, payload: data });
      alert("You Order is Placed Successfully.");
      window.location.reload();
      //Send Order Confirmation to User

    } catch (error) {
      console.log(error.message);
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_COD_FAIL,
        payload: message,
      });
    }
  };

// ORDER PAY
export const payOrder =
  (orderId, paymentResult) => async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_PAY_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        BASE_URL + `/api/orders/${orderId}/pay`,
        paymentResult,
        config
      );
      dispatch({ type: ORDER_PAY_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_PAY_FAIL,
        payload: message,
      });
    }
  };

// USER ORDERS
export const listMyOrders =
  (currentpage = 1) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_LIST_MY_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        BASE_URL +
          `/api/orders` +
          (currentpage !== 0 ? `?pageNumber=` + currentpage : ""),
        config
      );
      dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_LIST_MY_FAIL,
        payload: message,
      });
    }
  };

// ORDER COD
export const OrderCancellationRequest =
  (orderId) => async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_LIST_MY_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        BASE_URL + `/api/orders/${orderId}/cancel`,
        {},
        config
      );

      dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data });
      // alert("You Order is Placed Successfully.");
      // window.location.reload();
    } catch (error) {
      console.log(error.message);
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_LIST_MY_FAIL,
        payload: message,
      });
    }
  };

// USER FAILED ORDER
export const listFailedOrder =
  (limit = 1) =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: ORDER_LIST_MY_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(
        BASE_URL + `/api/users/order-failed?limit=` + 1,
        config
      );
      dispatch({ type: ORDER_LIST_MY_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      dispatch({
        type: ORDER_LIST_MY_FAIL,
        payload: message,
      });
    }
  };
